import React from 'react';
import { Box, IconButton, Drawer } from '@mui/material';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const MotionLink = motion(Link);

interface NavDrawerProps {
    open: boolean;
    onClose: () => void;
    links: { label: string; href: string }[];
}

const NavDrawer = ({ open, onClose, links }: NavDrawerProps) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        width: '100%',
                        maxWidth: '100%',
                        backgroundColor: '#111827',
                        color: '#F5F5F2',
                    },
                },
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6%' }}>
                <IconButton onClick={onClose} sx={{ color: '#F5F5F2' }}>
                    <Box sx={{ position: 'relative', width: 22, height: 22 }}>
                        <Box sx={{ position: 'absolute', top: '50%', left: 0, width: '100%', height: '1.5px', backgroundColor: '#F5F5F2', transform: 'rotate(45deg)' }} />
                        <Box sx={{ position: 'absolute', top: '50%', left: 0, width: '100%', height: '1.5px', backgroundColor: '#F5F5F2', transform: 'rotate(-45deg)' }} />
                    </Box>
                </IconButton>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    px: '10%',
                    mt: 4,
                }}
            >
                {links.map((link, i) => (
                    <MotionLink
                        key={link.label}
                        to={link.href}
                        onClick={onClose}
                        initial={{ opacity: 0, y: 12 }}
                        animate={open ? { opacity: 1, y: 0 } : {}}
                        transition={{ duration: 0.4, delay: 0.06 * i, ease: [0.22, 1, 0.36, 1] }}
                        style={{
                            fontSize: '2.4rem',
                            fontWeight: 500,
                            color: '#F5F5F2',
                            textDecoration: 'none',
                            letterSpacing: '-0.01em',
                        }}
                    >
                        {link.label}
                    </MotionLink>
                ))}
            </Box>
        </Drawer>
    );
};

export default NavDrawer;
